/** Agent team page — non-English overrides */
export const panelAgentTeamByLang = {
  es: {
    'agent.page.team': 'Mi equipo',
    'agent.layout.nav.team': 'Mi equipo',
    'agent.team.overview.totalMembers': 'Miembros del equipo',
    'agent.team.overview.activeInvestors': 'Inversores activos',
    'agent.team.overview.totalInvested': 'Inversión total del equipo',
    'agent.team.overview.directUsers': '{{n}} usuarios directos',
    'agent.team.overview.indirectUsers': '{{n}} usuarios indirectos',
    'agent.team.overview.directAgents': '{{n}} agentes directos',
    'agent.team.overview.indirectAgents': '{{n}} agentes indirectos',
    'agent.team.investment.title': 'Desglose de inversión del equipo',
    'agent.team.investment.directUser': 'Inversión de usuarios directos',
    'agent.team.investment.indirectUser': 'Inversión de usuarios indirectos',
    'agent.team.investment.commissionPool': 'Pool de comisiones estimado',
    'agent.team.investment.directMembers': '{{n}} miembros directos',
    'agent.team.investment.indirectMembers': '{{n}} miembros indirectos',
    'agent.team.investment.rateLine': 'Directo {{direct}} + Indirecto {{indirect}}',
    'agent.team.investment.avg': 'prom. {{amount}}',
    'agent.team.investment.total': 'Inversión total del equipo',
    'agent.team.members.title': 'Miembros del equipo',
    'agent.team.members.filter.all': 'Todos',
    'agent.team.members.filter.direct': 'Directo',
    'agent.team.members.filter.indirect': 'Indirecto',
    'agent.team.members.filter.invested': 'Con inversión',
    'agent.team.members.filter.notInvested': 'Sin inversión',
    'agent.team.members.filter.agents': 'Agentes',
    'agent.team.members.filter.users': 'Usuarios',
    'agent.team.members.searchPlaceholder': 'Buscar por usuario o correo',
    'agent.team.members.col.userId': 'ID de usuario',
    'agent.team.members.col.type': 'Tipo',
    'agent.team.members.col.member': 'Miembro',
    'agent.team.members.col.joined': 'Registro',
    'agent.team.members.col.invested': 'Monto invertido',
    'agent.team.members.col.status': 'Estado',
    'agent.team.members.loading': 'Cargando miembros del equipo…',
    'agent.team.members.empty': 'No se encontraron miembros del equipo.',
    'agent.team.members.showing': 'Mostrando {{n}} miembros',
    'agent.team.level.direct': 'Directo',
    'agent.team.level.indirect': 'Indirecto',
    'agent.team.memberType.agent': 'Agente',
    'agent.team.memberType.user': 'Usuario',
    'agent.team.status.active': 'Activo',
    'agent.team.status.suspended': 'Suspendido',
  },
  de: {
    'agent.page.team': 'Mein Team',
    'agent.layout.nav.team': 'Mein Team',
    'agent.team.overview.totalMembers': 'Teammitglieder gesamt',
    'agent.team.overview.activeInvestors': 'Aktive Investoren',
    'agent.team.overview.totalInvested': 'Team-Investitionen gesamt',
    'agent.team.overview.directUsers': '{{n}} direkte Nutzer',
    'agent.team.overview.indirectUsers': '{{n}} indirekte Nutzer',
    'agent.team.overview.directAgents': '{{n}} direkte Agenten',
    'agent.team.overview.indirectAgents': '{{n}} indirekte Agenten',
    'agent.team.investment.title': 'Team-Investitionsübersicht',
    'agent.team.investment.directUser': 'Direkte Nutzer-Investitionen',
    'agent.team.investment.indirectUser': 'Indirekte Nutzer-Investitionen',
    'agent.team.investment.commissionPool': 'Geschätzter Provisionspool',
    'agent.team.investment.directMembers': '{{n}} direkte Mitglieder',
    'agent.team.investment.indirectMembers': '{{n}} indirekte Mitglieder',
    'agent.team.investment.rateLine': 'Direkt {{direct}} + Indirekt {{indirect}}',
    'agent.team.investment.avg': 'Ø {{amount}}',
    'agent.team.investment.total': 'Team-Investitionen gesamt',
    'agent.team.members.title': 'Teammitglieder',
    'agent.team.members.filter.all': 'Alle',
    'agent.team.members.filter.direct': 'Direkt',
    'agent.team.members.filter.indirect': 'Indirekt',
    'agent.team.members.filter.invested': 'Investiert',
    'agent.team.members.filter.notInvested': 'Nicht investiert',
    'agent.team.members.filter.agents': 'Agenten',
    'agent.team.members.filter.users': 'Nutzer',
    'agent.team.members.searchPlaceholder': 'Nach Benutzername oder E-Mail suchen',
    'agent.team.members.col.userId': 'Benutzer-ID',
    'agent.team.members.col.type': 'Typ',
    'agent.team.members.col.member': 'Mitglied',
    'agent.team.members.col.joined': 'Beigetreten',
    'agent.team.members.col.invested': 'Investierter Betrag',
    'agent.team.members.col.status': 'Status',
    'agent.team.members.loading': 'Teammitglieder werden geladen…',
    'agent.team.members.empty': 'Keine Teammitglieder gefunden.',
    'agent.team.members.showing': '{{n}} Mitglieder angezeigt',
    'agent.team.level.direct': 'Direkt',
    'agent.team.level.indirect': 'Indirekt',
    'agent.team.memberType.agent': 'Agent',
    'agent.team.memberType.user': 'Nutzer',
    'agent.team.status.active': 'Aktiv',
    'agent.team.status.suspended': 'Gesperrt',
  },
  fr: {
    'agent.page.team': 'Mon équipe',
    'agent.layout.nav.team': 'Mon équipe',
    'agent.team.overview.totalMembers': 'Membres de l\'équipe',
    'agent.team.overview.activeInvestors': 'Investisseurs actifs',
    'agent.team.overview.totalInvested': 'Investissement total de l\'équipe',
    'agent.team.overview.directUsers': '{{n}} utilisateurs directs',
    'agent.team.overview.indirectUsers': '{{n}} utilisateurs indirects',
    'agent.team.overview.directAgents': '{{n}} agents directs',
    'agent.team.overview.indirectAgents': '{{n}} agents indirects',
    'agent.team.investment.title': 'Répartition des investissements de l\'équipe',
    'agent.team.investment.directUser': 'Investissement utilisateurs directs',
    'agent.team.investment.indirectUser': 'Investissement utilisateurs indirects',
    'agent.team.investment.commissionPool': 'Pool de commissions estimé',
    'agent.team.investment.directMembers': '{{n}} membres directs',
    'agent.team.investment.indirectMembers': '{{n}} membres indirects',
    'agent.team.investment.rateLine': 'Direct {{direct}} + Indirect {{indirect}}',
    'agent.team.investment.avg': 'moy. {{amount}}',
    'agent.team.investment.total': 'Investissement total de l\'équipe',
    'agent.team.members.title': 'Membres de l\'équipe',
    'agent.team.members.filter.all': 'Tous',
    'agent.team.members.filter.direct': 'Direct',
    'agent.team.members.filter.indirect': 'Indirect',
    'agent.team.members.filter.invested': 'Investi',
    'agent.team.members.filter.notInvested': 'Non investi',
    'agent.team.members.filter.agents': 'Agents',
    'agent.team.members.filter.users': 'Utilisateurs',
    'agent.team.members.searchPlaceholder': 'Rechercher par nom d\'utilisateur ou e-mail',
    'agent.team.members.col.userId': 'ID utilisateur',
    'agent.team.members.col.type': 'Type',
    'agent.team.members.col.member': 'Membre',
    'agent.team.members.col.joined': 'Inscription',
    'agent.team.members.col.invested': 'Montant investi',
    'agent.team.members.col.status': 'Statut',
    'agent.team.members.loading': 'Chargement des membres de l\'équipe…',
    'agent.team.members.empty': 'Aucun membre de l\'équipe trouvé.',
    'agent.team.members.showing': '{{n}} membres affichés',
    'agent.team.level.direct': 'Direct',
    'agent.team.level.indirect': 'Indirect',
    'agent.team.memberType.agent': 'Agent',
    'agent.team.memberType.user': 'Utilisateur',
    'agent.team.status.active': 'Actif',
    'agent.team.status.suspended': 'Suspendu',
  },
  ar: {
    'agent.page.team': 'فريقي',
    'agent.layout.nav.team': 'فريقي',
    'agent.team.overview.totalMembers': 'إجمالي أعضاء الفريق',
    'agent.team.overview.activeInvestors': 'المستثمرون النشطون',
    'agent.team.overview.totalInvested': 'إجمالي استثمار الفريق',
    'agent.team.overview.directUsers': '{{n}} مستخدمين مباشرين',
    'agent.team.overview.indirectUsers': '{{n}} مستخدمين غير مباشرين',
    'agent.team.overview.directAgents': '{{n}} وكلاء مباشرين',
    'agent.team.overview.indirectAgents': '{{n}} وكلاء غير مباشرين',
    'agent.team.investment.title': 'تفصيل استثمار الفريق',
    'agent.team.investment.directUser': 'استثمار المستخدمين المباشرين',
    'agent.team.investment.indirectUser': 'استثمار المستخدمين غير المباشرين',
    'agent.team.investment.commissionPool': 'مجموعة العمولات المقدرة',
    'agent.team.investment.directMembers': '{{n}} أعضاء مباشرين',
    'agent.team.investment.indirectMembers': '{{n}} أعضاء غير مباشرين',
    'agent.team.investment.rateLine': 'مباشر {{direct}} + غير مباشر {{indirect}}',
    'agent.team.investment.avg': 'متوسط {{amount}}',
    'agent.team.investment.total': 'إجمالي استثمار الفريق',
    'agent.team.members.title': 'أعضاء الفريق',
    'agent.team.members.filter.all': 'الكل',
    'agent.team.members.filter.direct': 'مباشر',
    'agent.team.members.filter.indirect': 'غير مباشر',
    'agent.team.members.filter.invested': 'مستثمر',
    'agent.team.members.filter.notInvested': 'غير مستثمر',
    'agent.team.members.filter.agents': 'وكلاء',
    'agent.team.members.filter.users': 'مستخدمون',
    'agent.team.members.searchPlaceholder': 'البحث باسم المستخدم أو البريد',
    'agent.team.members.col.userId': 'معرف المستخدم',
    'agent.team.members.col.type': 'النوع',
    'agent.team.members.col.member': 'العضو',
    'agent.team.members.col.joined': 'تاريخ الانضمام',
    'agent.team.members.col.invested': 'المبلغ المستثمر',
    'agent.team.members.col.status': 'الحالة',
    'agent.team.members.loading': 'جاري تحميل أعضاء الفريق…',
    'agent.team.members.empty': 'لم يتم العثور على أعضاء في الفريق.',
    'agent.team.members.showing': 'عرض {{n}} عضو',
    'agent.team.level.direct': 'مباشر',
    'agent.team.level.indirect': 'غير مباشر',
    'agent.team.memberType.agent': 'وكيل',
    'agent.team.memberType.user': 'مستخدم',
    'agent.team.status.active': 'نشط',
    'agent.team.status.suspended': 'موقوف',
  },
  ja: {
    'agent.page.team': 'マイチーム',
    'agent.layout.nav.team': 'マイチーム',
    'agent.team.overview.totalMembers': 'チームメンバー総数',
    'agent.team.overview.activeInvestors': 'アクティブ投資家',
    'agent.team.overview.totalInvested': 'チーム投資総額',
    'agent.team.overview.directUsers': '直接ユーザー {{n}}',
    'agent.team.overview.indirectUsers': '間接ユーザー {{n}}',
    'agent.team.overview.directAgents': '直接エージェント {{n}}',
    'agent.team.overview.indirectAgents': '間接エージェント {{n}}',
    'agent.team.investment.title': 'チーム投資の内訳',
    'agent.team.investment.directUser': '直接ユーザーのチーム投資',
    'agent.team.investment.indirectUser': '間接ユーザーのチーム投資',
    'agent.team.investment.commissionPool': '推定コミッションプール',
    'agent.team.investment.directMembers': '直接メンバー {{n}}',
    'agent.team.investment.indirectMembers': '間接メンバー {{n}}',
    'agent.team.investment.rateLine': '直接 {{direct}} + 間接 {{indirect}}',
    'agent.team.investment.avg': '平均 {{amount}}',
    'agent.team.investment.total': 'チーム投資総額',
    'agent.team.members.title': 'チームメンバー',
    'agent.team.members.filter.all': 'すべて',
    'agent.team.members.filter.direct': '直接',
    'agent.team.members.filter.indirect': '間接',
    'agent.team.members.filter.invested': '投資あり',
    'agent.team.members.filter.notInvested': '未投資',
    'agent.team.members.filter.agents': 'エージェント',
    'agent.team.members.filter.users': 'ユーザー',
    'agent.team.members.searchPlaceholder': 'ユーザー名またはメールで検索',
    'agent.team.members.col.userId': 'ユーザーID',
    'agent.team.members.col.type': 'タイプ',
    'agent.team.members.col.member': 'メンバー',
    'agent.team.members.col.joined': '参加日',
    'agent.team.members.col.invested': '投資額',
    'agent.team.members.col.status': 'ステータス',
    'agent.team.members.loading': 'チームメンバーを読み込み中…',
    'agent.team.members.empty': 'チームメンバーが見つかりません。',
    'agent.team.members.showing': '{{n}} 件のメンバーを表示',
    'agent.team.level.direct': '直接',
    'agent.team.level.indirect': '間接',
    'agent.team.memberType.agent': 'エージェント',
    'agent.team.memberType.user': 'ユーザー',
    'agent.team.status.active': 'アクティブ',
    'agent.team.status.suspended': '停止中',
  },
  ko: {
    'agent.page.team': '내 팀',
    'agent.layout.nav.team': '내 팀',
    'agent.team.overview.totalMembers': '팀 멤버 총수',
    'agent.team.overview.activeInvestors': '활성 투자자',
    'agent.team.overview.totalInvested': '팀 총 투자액',
    'agent.team.overview.directUsers': '직접 사용자 {{n}}',
    'agent.team.overview.indirectUsers': '간접 사용자 {{n}}',
    'agent.team.overview.directAgents': '직접 에이전트 {{n}}',
    'agent.team.overview.indirectAgents': '간접 에이전트 {{n}}',
    'agent.team.investment.title': '팀 투자 분석',
    'agent.team.investment.directUser': '직접 사용자 팀 투자',
    'agent.team.investment.indirectUser': '간접 사용자 팀 투자',
    'agent.team.investment.commissionPool': '예상 커미션 풀',
    'agent.team.investment.directMembers': '직접 멤버 {{n}}',
    'agent.team.investment.indirectMembers': '간접 멤버 {{n}}',
    'agent.team.investment.rateLine': '직접 {{direct}} + 간접 {{indirect}}',
    'agent.team.investment.avg': '평균 {{amount}}',
    'agent.team.investment.total': '팀 총 투자액',
    'agent.team.members.title': '팀 멤버',
    'agent.team.members.filter.all': '전체',
    'agent.team.members.filter.direct': '직접',
    'agent.team.members.filter.indirect': '간접',
    'agent.team.members.filter.invested': '투자함',
    'agent.team.members.filter.notInvested': '미투자',
    'agent.team.members.filter.agents': '에이전트',
    'agent.team.members.filter.users': '사용자',
    'agent.team.members.searchPlaceholder': '사용자명 또는 이메일 검색',
    'agent.team.members.col.userId': '사용자 ID',
    'agent.team.members.col.type': '유형',
    'agent.team.members.col.member': '멤버',
    'agent.team.members.col.joined': '가입일',
    'agent.team.members.col.invested': '투자 금액',
    'agent.team.members.col.status': '상태',
    'agent.team.members.loading': '팀 멤버 불러오는 중…',
    'agent.team.members.empty': '팀 멤버를 찾을 수 없습니다.',
    'agent.team.members.showing': '{{n}}명의 멤버 표시',
    'agent.team.level.direct': '직접',
    'agent.team.level.indirect': '간접',
    'agent.team.memberType.agent': '에이전트',
    'agent.team.memberType.user': '사용자',
    'agent.team.status.active': '활성',
    'agent.team.status.suspended': '정지됨',
  },
  'zh-CN': {
    'agent.page.team': '我的团队',
    'agent.layout.nav.team': '我的团队',
    'agent.team.overview.totalMembers': '团队成员总数',
    'agent.team.overview.activeInvestors': '活跃投资者',
    'agent.team.overview.totalInvested': '团队总投资',
    'agent.team.overview.directUsers': '{{n}} 名直接用户',
    'agent.team.overview.indirectUsers': '{{n}} 名间接用户',
    'agent.team.overview.directAgents': '{{n}} 名直接代理',
    'agent.team.overview.indirectAgents': '{{n}} 名间接代理',
    'agent.team.investment.title': '团队投资明细',
    'agent.team.investment.directUser': '直接用户团队投资',
    'agent.team.investment.indirectUser': '间接用户团队投资',
    'agent.team.investment.commissionPool': '预估佣金池',
    'agent.team.investment.directMembers': '{{n}} 名直接成员',
    'agent.team.investment.indirectMembers': '{{n}} 名间接成员',
    'agent.team.investment.rateLine': '直接 {{direct}} + 间接 {{indirect}}',
    'agent.team.investment.avg': '平均 {{amount}}',
    'agent.team.investment.total': '团队总投资',
    'agent.team.members.title': '团队成员',
    'agent.team.members.filter.all': '全部',
    'agent.team.members.filter.direct': '直接',
    'agent.team.members.filter.indirect': '间接',
    'agent.team.members.filter.invested': '已投资',
    'agent.team.members.filter.notInvested': '未投资',
    'agent.team.members.filter.agents': '代理',
    'agent.team.members.filter.users': '用户',
    'agent.team.members.searchPlaceholder': '按用户名或邮箱搜索',
    'agent.team.members.col.userId': '用户 ID',
    'agent.team.members.col.type': '类型',
    'agent.team.members.col.member': '成员',
    'agent.team.members.col.joined': '加入日期',
    'agent.team.members.col.invested': '投资金额',
    'agent.team.members.col.status': '状态',
    'agent.team.members.loading': '正在加载团队成员…',
    'agent.team.members.empty': '未找到团队成员。',
    'agent.team.members.showing': '显示 {{n}} 名成员',
    'agent.team.level.direct': '直接',
    'agent.team.level.indirect': '间接',
    'agent.team.memberType.agent': '代理',
    'agent.team.memberType.user': '用户',
    'agent.team.status.active': '活跃',
    'agent.team.status.suspended': '已暂停',
  },
  pt: {
    'agent.page.team': 'Minha equipe',
    'agent.layout.nav.team': 'Minha equipe',
    'agent.team.overview.totalMembers': 'Total de membros da equipe',
    'agent.team.overview.activeInvestors': 'Investidores ativos',
    'agent.team.overview.totalInvested': 'Investimento total da equipe',
    'agent.team.overview.directUsers': '{{n}} usuários diretos',
    'agent.team.overview.indirectUsers': '{{n}} usuários indiretos',
    'agent.team.overview.directAgents': '{{n}} agentes diretos',
    'agent.team.overview.indirectAgents': '{{n}} agentes indiretos',
    'agent.team.investment.title': 'Detalhamento de investimento da equipe',
    'agent.team.investment.directUser': 'Investimento de usuários diretos',
    'agent.team.investment.indirectUser': 'Investimento de usuários indiretos',
    'agent.team.investment.commissionPool': 'Pool de comissões estimado',
    'agent.team.investment.directMembers': '{{n}} membros diretos',
    'agent.team.investment.indirectMembers': '{{n}} membros indiretos',
    'agent.team.investment.rateLine': 'Direto {{direct}} + Indireto {{indirect}}',
    'agent.team.investment.avg': 'méd. {{amount}}',
    'agent.team.investment.total': 'Investimento total da equipe',
    'agent.team.members.title': 'Membros da equipe',
    'agent.team.members.filter.all': 'Todos',
    'agent.team.members.filter.direct': 'Direto',
    'agent.team.members.filter.indirect': 'Indireto',
    'agent.team.members.filter.invested': 'Investiu',
    'agent.team.members.filter.notInvested': 'Não investiu',
    'agent.team.members.filter.agents': 'Agentes',
    'agent.team.members.filter.users': 'Usuários',
    'agent.team.members.searchPlaceholder': 'Buscar por usuário ou e-mail',
    'agent.team.members.col.userId': 'ID do usuário',
    'agent.team.members.col.type': 'Tipo',
    'agent.team.members.col.member': 'Membro',
    'agent.team.members.col.joined': 'Cadastro',
    'agent.team.members.col.invested': 'Valor investido',
    'agent.team.members.col.status': 'Status',
    'agent.team.members.loading': 'Carregando membros da equipe…',
    'agent.team.members.empty': 'Nenhum membro da equipe encontrado.',
    'agent.team.members.showing': 'Mostrando {{n}} membros',
    'agent.team.level.direct': 'Direto',
    'agent.team.level.indirect': 'Indireto',
    'agent.team.memberType.agent': 'Agente',
    'agent.team.memberType.user': 'Usuário',
    'agent.team.status.active': 'Ativo',
    'agent.team.status.suspended': 'Suspenso',
  },
  it: {
    'agent.page.team': 'Il mio team',
    'agent.layout.nav.team': 'Il mio team',
    'agent.team.overview.totalMembers': 'Membri del team totali',
    'agent.team.overview.activeInvestors': 'Investitori attivi',
    'agent.team.overview.totalInvested': 'Investimento totale del team',
    'agent.team.overview.directUsers': '{{n}} utenti diretti',
    'agent.team.overview.indirectUsers': '{{n}} utenti indiretti',
    'agent.team.overview.directAgents': '{{n}} agenti diretti',
    'agent.team.overview.indirectAgents': '{{n}} agenti indiretti',
    'agent.team.investment.title': 'Ripartizione investimenti del team',
    'agent.team.investment.directUser': 'Investimento utenti diretti',
    'agent.team.investment.indirectUser': 'Investimento utenti indiretti',
    'agent.team.investment.commissionPool': 'Pool commissioni stimato',
    'agent.team.investment.directMembers': '{{n}} membri diretti',
    'agent.team.investment.indirectMembers': '{{n}} membri indiretti',
    'agent.team.investment.rateLine': 'Diretto {{direct}} + Indiretto {{indirect}}',
    'agent.team.investment.avg': 'media {{amount}}',
    'agent.team.investment.total': 'Investimento totale del team',
    'agent.team.members.title': 'Membri del team',
    'agent.team.members.filter.all': 'Tutti',
    'agent.team.members.filter.direct': 'Diretto',
    'agent.team.members.filter.indirect': 'Indiretto',
    'agent.team.members.filter.invested': 'Investito',
    'agent.team.members.filter.notInvested': 'Non investito',
    'agent.team.members.filter.agents': 'Agenti',
    'agent.team.members.filter.users': 'Utenti',
    'agent.team.members.searchPlaceholder': 'Cerca per username o email',
    'agent.team.members.col.userId': 'ID utente',
    'agent.team.members.col.type': 'Tipo',
    'agent.team.members.col.member': 'Membro',
    'agent.team.members.col.joined': 'Iscrizione',
    'agent.team.members.col.invested': 'Importo investito',
    'agent.team.members.col.status': 'Stato',
    'agent.team.members.loading': 'Caricamento membri del team…',
    'agent.team.members.empty': 'Nessun membro del team trovato.',
    'agent.team.members.showing': '{{n}} membri mostrati',
    'agent.team.level.direct': 'Diretto',
    'agent.team.level.indirect': 'Indiretto',
    'agent.team.memberType.agent': 'Agente',
    'agent.team.memberType.user': 'Utente',
    'agent.team.status.active': 'Attivo',
    'agent.team.status.suspended': 'Sospeso',
  },
  ru: {
    'agent.page.team': 'Моя команда',
    'agent.layout.nav.team': 'Моя команда',
    'agent.team.overview.totalMembers': 'Всего в команде',
    'agent.team.overview.activeInvestors': 'Активные инвесторы',
    'agent.team.overview.totalInvested': 'Общие инвестиции команды',
    'agent.team.overview.directUsers': '{{n}} прямых пользователей',
    'agent.team.overview.indirectUsers': '{{n}} косвенных пользователей',
    'agent.team.overview.directAgents': '{{n}} прямых агентов',
    'agent.team.overview.indirectAgents': '{{n}} косвенных агентов',
    'agent.team.investment.title': 'Структура инвестиций команды',
    'agent.team.investment.directUser': 'Инвестиции прямых пользователей',
    'agent.team.investment.indirectUser': 'Инвестиции косвенных пользователей',
    'agent.team.investment.commissionPool': 'Оценочный пул комиссий',
    'agent.team.investment.directMembers': '{{n}} прямых участников',
    'agent.team.investment.indirectMembers': '{{n}} косвенных участников',
    'agent.team.investment.rateLine': 'Прямой {{direct}} + Косвенный {{indirect}}',
    'agent.team.investment.avg': 'ср. {{amount}}',
    'agent.team.investment.total': 'Общие инвестиции команды',
    'agent.team.members.title': 'Участники команды',
    'agent.team.members.filter.all': 'Все',
    'agent.team.members.filter.direct': 'Прямой',
    'agent.team.members.filter.indirect': 'Косвенный',
    'agent.team.members.filter.invested': 'Инвестировал',
    'agent.team.members.filter.notInvested': 'Не инвестировал',
    'agent.team.members.filter.agents': 'Агенты',
    'agent.team.members.filter.users': 'Пользователи',
    'agent.team.members.searchPlaceholder': 'Поиск по имени или email',
    'agent.team.members.col.userId': 'ID пользователя',
    'agent.team.members.col.type': 'Тип',
    'agent.team.members.col.member': 'Участник',
    'agent.team.members.col.joined': 'Дата регистрации',
    'agent.team.members.col.invested': 'Сумма инвестиций',
    'agent.team.members.col.status': 'Статус',
    'agent.team.members.loading': 'Загрузка участников команды…',
    'agent.team.members.empty': 'Участники команды не найдены.',
    'agent.team.members.showing': 'Показано участников: {{n}}',
    'agent.team.level.direct': 'Прямой',
    'agent.team.level.indirect': 'Косвенный',
    'agent.team.memberType.agent': 'Агент',
    'agent.team.memberType.user': 'Пользователь',
    'agent.team.status.active': 'Активен',
    'agent.team.status.suspended': 'Приостановлен',
  },
  bn: {
    'agent.page.team': 'আমার দল',
    'agent.layout.nav.team': 'আমার দল',
    'agent.team.overview.totalMembers': 'মোট দলের সদস্য',
    'agent.team.overview.activeInvestors': 'সক্রিয় বিনিয়োগকারী',
    'agent.team.overview.totalInvested': 'দলের মোট বিনিয়োগ',
    'agent.team.overview.directUsers': '{{n}} সরাসরি ব্যবহারকারী',
    'agent.team.overview.indirectUsers': '{{n}} পরোক্ষ ব্যবহারকারী',
    'agent.team.overview.directAgents': '{{n}} সরাসরি এজেন্ট',
    'agent.team.overview.indirectAgents': '{{n}} পরোক্ষ এজেন্ট',
    'agent.team.investment.title': 'দলের বিনিয়োগ বিশ্লেষণ',
    'agent.team.investment.directUser': 'সরাসরি ব্যবহারকারী দল বিনিয়োগ',
    'agent.team.investment.indirectUser': 'পরোক্ষ ব্যবহারকারী দল বিনিয়োগ',
    'agent.team.investment.commissionPool': 'আনুমানিক কমিশন পুল',
    'agent.team.investment.directMembers': '{{n}} সরাসরি সদস্য',
    'agent.team.investment.indirectMembers': '{{n}} পরোক্ষ সদস্য',
    'agent.team.investment.rateLine': 'সরাসরি {{direct}} + পরোক্ষ {{indirect}}',
    'agent.team.investment.avg': 'গড় {{amount}}',
    'agent.team.investment.total': 'দলের মোট বিনিয়োগ',
    'agent.team.members.title': 'দলের সদস্য',
    'agent.team.members.filter.all': 'সব',
    'agent.team.members.filter.direct': 'সরাসরি',
    'agent.team.members.filter.indirect': 'পরোক্ষ',
    'agent.team.members.filter.invested': 'বিনিয়োগ করেছে',
    'agent.team.members.filter.notInvested': 'বিনিয়োগ করেনি',
    'agent.team.members.filter.agents': 'এজেন্ট',
    'agent.team.members.filter.users': 'ব্যবহারকারী',
    'agent.team.members.searchPlaceholder': 'ব্যবহারকারীনাম বা ইমেইলে খুঁজুন',
    'agent.team.members.col.userId': 'ব্যবহারকারী ID',
    'agent.team.members.col.type': 'ধরন',
    'agent.team.members.col.member': 'সদস্য',
    'agent.team.members.col.joined': 'যোগদান',
    'agent.team.members.col.invested': 'বিনিয়োগের পরিমাণ',
    'agent.team.members.col.status': 'স্থিতি',
    'agent.team.members.loading': 'দলের সদস্য লোড হচ্ছে…',
    'agent.team.members.empty': 'কোনো দলের সদস্য পাওয়া যায়নি।',
    'agent.team.members.showing': '{{n}} সদস্য দেখানো হচ্ছে',
    'agent.team.level.direct': 'সরাসরি',
    'agent.team.level.indirect': 'পরোক্ষ',
    'agent.team.memberType.agent': 'এজেন্ট',
    'agent.team.memberType.user': 'ব্যবহারকারী',
    'agent.team.status.active': 'সক্রিয়',
    'agent.team.status.suspended': 'স্থগিত',
  },
  hi: {
    'agent.page.team': 'मेरी टीम',
    'agent.layout.nav.team': 'मेरी टीम',
    'agent.team.overview.totalMembers': 'कुल टीम सदस्य',
    'agent.team.overview.activeInvestors': 'सक्रिय निवेशक',
    'agent.team.overview.totalInvested': 'टीम का कुल निवेश',
    'agent.team.overview.directUsers': '{{n}} प्रत्यक्ष उपयोगकर्ता',
    'agent.team.overview.indirectUsers': '{{n}} अप्रत्यक्ष उपयोगकर्ता',
    'agent.team.overview.directAgents': '{{n}} प्रत्यक्ष एजेंट',
    'agent.team.overview.indirectAgents': '{{n}} अप्रत्यक्ष एजेंट',
    'agent.team.investment.title': 'टीम निवेश विवरण',
    'agent.team.investment.directUser': 'प्रत्यक्ष उपयोगकर्ता टीम निवेश',
    'agent.team.investment.indirectUser': 'अप्रत्यक्ष उपयोगकर्ता टीम निवेश',
    'agent.team.investment.commissionPool': 'अनुमानित कमीशन पूल',
    'agent.team.investment.directMembers': '{{n}} प्रत्यक्ष सदस्य',
    'agent.team.investment.indirectMembers': '{{n}} अप्रत्यक्ष सदस्य',
    'agent.team.investment.rateLine': 'प्रत्यक्ष {{direct}} + अप्रत्यक्ष {{indirect}}',
    'agent.team.investment.avg': 'औसत {{amount}}',
    'agent.team.investment.total': 'टीम का कुल निवेश',
    'agent.team.members.title': 'टीम के सदस्य',
    'agent.team.members.filter.all': 'सभी',
    'agent.team.members.filter.direct': 'प्रत्यक्ष',
    'agent.team.members.filter.indirect': 'अप्रत्यक्ष',
    'agent.team.members.filter.invested': 'निवेश किया',
    'agent.team.members.filter.notInvested': 'निवेश नहीं',
    'agent.team.members.filter.agents': 'एजेंट',
    'agent.team.members.filter.users': 'उपयोगकर्ता',
    'agent.team.members.searchPlaceholder': 'उपयोगकर्ता नाम या ईमेल से खोजें',
    'agent.team.members.col.userId': 'उपयोगकर्ता ID',
    'agent.team.members.col.type': 'प्रकार',
    'agent.team.members.col.member': 'सदस्य',
    'agent.team.members.col.joined': 'शामिल हुए',
    'agent.team.members.col.invested': 'निवेश राशि',
    'agent.team.members.col.status': 'स्थिति',
    'agent.team.members.loading': 'टीम सदस्य लोड हो रहे हैं…',
    'agent.team.members.empty': 'कोई टीम सदस्य नहीं मिला।',
    'agent.team.members.showing': '{{n}} सदस्य दिखाए जा रहे हैं',
    'agent.team.level.direct': 'प्रत्यक्ष',
    'agent.team.level.indirect': 'अप्रत्यक्ष',
    'agent.team.memberType.agent': 'एजेंट',
    'agent.team.memberType.user': 'उपयोगकर्ता',
    'agent.team.status.active': 'सक्रिय',
    'agent.team.status.suspended': 'निलंबित',
  },
};
